import React, { useState } from "react";
import { Box, Typography, Button, Tab, Tabs } from "@mui/material";
import BaseDrawer from "../../components/UI/BaseDrawer/BaseDrawer";
import UsernameReset from "./TransferDrawerComponents/UsernameReset";
import LoanSetup from "../../pages/LoanSetup/LoanSetup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="tab-panel-container"
    >
      {value === index && (
        <Box className="tab-panel-outer-box" sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function TransferDrawer({ selectedUser, selectedUserData, isOpen, closeTransfers, updateTableStatus }) {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };

    return (
    <Box
        class="offcanvas offcanvas-end dynamic-offcanvas"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
    >
        <Box class="customer-bottom-info">
            <Box class="text-end p-2">
                <Button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></Button>
            </Box>
            <Box class="accordion" id="profileAccordion">
                <Box class="accordion-item">
                    <Typography variant="h2" class="accordion-header" id="headingOne">
                        <Button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                        >
                            {`Customer Details: ${selectedUserData?.User?.id || 'N/A'} - ${selectedUserData?.User?.firstName || 'N/A'} ${selectedUserData?.User?.lastName || 'N/A'}`}
                        </Button>
                    </Typography>
                    <BaseDrawer
                        open={isOpen}
                        handleClose={closeTransfers}
                        height="80vh"
                        overflow="auto"
                    >
                        <Box sx={{ display: "flex", height: "100%" }} className="supper-admin-settings-tab-container">
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={value}
                                onChange={handleChange}
                                sx={{
                                    borderRight: 1,
                                    borderColor: "divider",
                                    //indicator color
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: "#ff972c",
                                    },
                                    //selected tabs
                                    "& .MuiButtonBase-root.Mui-selected": {
                                        color: "#ff972c",
                                    },
                                    //non selected tabs
                                    "& .MuiButtonBase-root": {
                                        color: "rgba(0, 0, 0, 0.87)",
                                    },
                                }}
                            >
                                <Tab label="Username Reset" />
                                {/* <Tab label="Loan Setup" /> */}
                            </Tabs>
                            <TabPanel value={value} index={0}>
                                <UsernameReset 
                                    selectedUserData={selectedUserData} 
                                    updateTableStatus={updateTableStatus} 
                                    handleClose={closeTransfers}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <LoanSetup />
                            </TabPanel>
                        </Box>
                    </BaseDrawer>
                </Box>
            </Box>
        </Box>
    </Box>);
}

export default TransferDrawer;